import * as _ from "lodash"
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {WB_ProductTypeRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Product_Type} from "../PA.Core/PAdbSchema";
import {ProductTypeBO} from "./ProductTypeBO";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class ProductTypeBOValidations {

    static async ValidateFields(aBO: ProductTypeBO): Promise<void> {
        const self = this;
        let dbContext = new PAdbContext({})

        let userContext = PAEnvironment.getValue(PAEnvironment.UserContext, 'UserContext')
        let bHasRole = userContext.hasRoleId("Product_Data_Editor")

        if (_.isEmpty(aBO.WB_ProductType.cif.PRDM_ID) && _.isEmpty(aBO.WB_ProductType.cif.PRDM_NAME) && !bHasRole){
            self.addMessage(aBO, "viewerRoleCreate", 'Only Users with Editor Role can Create a new Product Type')
            return
        } else {
            aBO.ValidateMessageProvider.removeMessage("viewerRoleCreate")
        }

        if(!bHasRole){
            self.addMessage(aBO, "viewerRoleSave", 'Only Users with Editor Role can update a Product Type')
            return
        } else {
            aBO.ValidateMessageProvider.removeMessage("viewerRoleSave")
        }

        if (aBO.WB_ProductType.cif.WB_MDSET_ID===0)
        {
            self.addMessage(aBO, "emptyMDSETID", 'MD Set cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyMDSETID")

        if (_.isEmpty(aBO.WB_ProductType.cif.PRDM_TYPE))
        {
            self.addMessage(aBO, "emptyEntityType", 'Entity Type cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyEntityType")

        if (_.isEmpty(aBO.WB_ProductType.cif.PRDM_ID))
        {
            self.addMessage(aBO, "emptyID", 'Product Type ID cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyID")
        if (_.isEmpty(aBO.WB_ProductType.cif.PRDM_NAME))
        {
            self.addMessage(aBO, "emptyName", 'Product Type Name cannot be empty')

        }
        else
            aBO.ValidateMessageProvider.removeMessage("emptyName")



        // Product Types are considered duplicates only within the same Master Data Set
        let productTypeRows: WB_ProductTypeRow[] = await dbContext.findAll(esWB_Product_Type,
            {where: {DELETED_IND: {neq: '1'},
                    WB_PRDM_ID: {neq: aBO.WB_ProductType.cif.WB_PRDM_ID},
                    WB_MDSET_ID: aBO.WB_ProductType.cif.WB_MDSET_ID,
                    PRDM_ID: aBO.WB_ProductType.cif.PRDM_ID}})


        if (!_.isEmpty(productTypeRows)) {
            self.addMessage(aBO, "duplicateID", 'Existing Product Type(s) with the same ID: ' +
                '\nProduct Types: ' + _.map(productTypeRows, (a) => a.cif.PRDM_NAME).join(", ")
            )
        } else {
            aBO.ValidateMessageProvider.removeMessage("duplicateID")
        }


    }

    private static addMessage(aBO: ProductTypeBO, code: string, message: string): void {
        aBO.ValidateMessageProvider.addMessage(
            {
                code: code,
                type: MessageType.Error,
                title: message,
                description: "",
                subtitle: "",
                count: 0
            });
    }
}